<template>
  <v-row justify="center">
    <v-dialog v-model="$store.state.openRepeatRequestDialog" width="524">
      <v-card>
        <v-card-title>
          <div>{{ label }}</div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  :items="items"
                  v-model="selectedValue"
                  outlined
                  dense
                  return-object
                  label="اختر الاستشاري"
                  item-text="name"
                >
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-bind="attrs" v-on="on">
                      <v-list-item-title
                        :id="attrs['aria-labelledby']"
                        v-text="item.name_for_admin || item.name"
                      ></v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="$store.state.openRepeatRequestDialog = false"
          >
            الغاء
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="handleRepeat"> تكرار الطلب </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["items", "label"],
  data: () => ({
    selectedValue: "",
  }),
  methods: {
    handleRepeat() {
      this.$store.state.openRepeatRequestDialog = false;
      //selected agent id
      this.$emit("selectedRepeatValue", this.selectedValue.id);
      this.selectedValue = '';
    },
  },
};
</script>
<style>
textarea{
  color:#000 !important;
}
</style>